import React, { useEffect, useState } from "react";
import Table from "../../components/table/Table";
import { customStyles } from "../../assets/styles/CustomStyle";
import UserManagementColumns from "../../assets/columns/UserManagementColumns";
import { useDispatch, useSelector } from "react-redux";
import WithPageHeader from "../../components/ui/withPageHeader";
import { createRecord, getRecords } from "../../redux/reducers";
import DropdownButton from "../../components/dropdown-button/DropdownButton";
import { FaBan, FaCheck, FaPen } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import userOrganizationStatus from "../../assets/values/userOrganizationStatus";
import Loader from "../../components/loader/loader";

const UserTabForManagement = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { usersList } = useSelector((state) => state.records?.current);
  const { loading, created, creating, searchText } = useSelector(
    (state) => state.records
  );
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [filteredData, setFilteredData] = useState(usersList?.data);
  const [perPage, setPerPage] = useState(usersList?.pageSize ?? 10);
  const [page, setPage] = useState(usersList?.pageNumber ?? 1);

  useEffect(() => {
    getUserManagement();
  }, [created, searchText?.generalSearch]);

  useEffect(() => {
    setFilteredData(usersList?.data);
  }, [usersList]);

  useEffect(() => {
    handlePaginationPerpage();
  }, [perPage, page]);

  const getUserManagement = () => {
    const params = {
      isPdmaUser: true,
      pageNumber: page,
      pageSize: perPage,
    };
    if (searchText?.generalSearch) {
      params.search = searchText.generalSearch;
    }
    dispatch({
      type: getRecords.type,
      payload: {
        url: "/User",
        params,
        appendCurrentReducerKey: "usersList",
      },
    });
  };

  const handlePaginationPerpage = () => {
    dispatch({
      type: getRecords.type,
      payload: {
        url: `/User?isPdmaUser=true&pageNumber=${page}&pageSize=${perPage}`,
        appendCurrentReducerKey: "usersList",
      },
    });
  };

  const filterByStatus = (type) => {
    setSelectedStatus(type);
    if (type === "All") {
      setFilteredData(usersList?.data);
    } else {
      const filtered = usersList?.data?.filter(
        (record) => record.status === type
      );

      setFilteredData(filtered);
    }
  };

  const getStatusClass = (type) => {
    return selectedStatus === type ? "active" : "";
  };

  const statusList = Object.entries(userOrganizationStatus).map(
    ([key, value]) => ({
      text: value,
      className: `${getStatusClass(value)}`,
      onClick: () => filterByStatus(value),
    })
  );

  const handleApprove = (id) => {
    dispatch({
      type: createRecord.type,
      payload: {
        url: `/User/${id}/approve`,
        message: "User Approved Successfully!",
      },
    });
  };
  const handleBlock = (id) => {
    dispatch({
      type: createRecord.type,
      payload: {
        url: `/User/${id}/block`,
        message: "User Blocked Successfully!",
      },
    });
  };

  const handleUpdateUser = (id) => {
    navigate(`/user-management/update/${id}`);
  };

  const actionPDMA = [
    {
      label: "Update",
      icon: FaPen,
      onClick: handleUpdateUser,
    },
    {
      label: "Approve",
      icon: FaCheck,
      onClick: handleApprove,
    },
    {
      label: "Block",
      icon: FaBan,
      onClick: handleBlock,
    },
  ];

  const columns = [
    ...UserManagementColumns,
    {
      name: "Action",
      width: "100px",
      cell: (row) => (
        <DropdownButton rowId={row?.userId} actions={actionPDMA} />
      ),
    },
  ];
  return (
    <div className="bg-white shadow-sm rounded p-3 mt-3 table-container-anim">
      <Loader loading={loading} />
      <WithPageHeader heading="RRSD Users List" buttons={[...statusList]} />
      <div className="mt-3">
        <Table
          loading={loading}
          columns={columns}
          customStyles={customStyles}
          data={filteredData}
          pagination
          paginationServer
          paginationTotalRows={usersList?.totalRecords}
          onChangeRowsPerPage={(pP) => {
            setPerPage(pP);
          }}
          onChangePage={(p) => {
            setPage(p);
          }}
          dense
        />
      </div>
    </div>
  );
};

export default UserTabForManagement;
